import React from 'react';
import { NavLink } from 'react-router-dom';

import GetInTouchButton from '@app/components/UI/Forms/GetInTouch/GetInTouchButton';
import { footerMenu } from '@app/components/UI/Footer/FooterMenuLinks';
import CarrotDownSVG from '@app/images/CarrotDownSVG';
import { FooterMenuItem } from '@app/objects/CustomMenuItem';

interface FooterMenuProps {
	isMobile?: boolean;
}

const FooterMenuColumn: React.FC<{ title: string }> = ({ title }) => {
	const [isOpen, setIsOpen] = React.useState(false);

	const toggleOpen = () => setIsOpen((prevState) => !prevState);

	return (
		<div className="site-footer-col">
			<h3 className="site-footer-col__title" onClick={toggleOpen}>
				{title}
				<CarrotDownSVG className={`site-footer-col__carrot site-footer-col__carrot_${isOpen ? 'up' : 'down'}`} />
			</h3>
			<ul className={`site-footer-col__content ${isOpen ? 'site-footer-col__content_open' : ''}`}>
				{footerMenu[title]?.map((item: FooterMenuItem, index) => (
					<li key={index} className="site-footer-col__item">
						{item.name === 'Contact Us' ? (
							<GetInTouchButton btnText={item.name} />
						) : item.name === 'Media Kit' || item.name === 'Join Our Team' || item.newTab ? (
							<a href={item.path} className="site-footer-col__link" target="_blank" rel="noopener noreferrer">
								{item.name}
							</a>
						) : (
							<NavLink to={item.path} className="site-footer-col__link" key={index}>
								{item.name}
							</NavLink>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};

const FooterMenu: React.FC<FooterMenuProps> = ({ isMobile = false }) => {
	return (
		<nav
			role="navigation"
			aria-label="Footer Navigation"
			className={`site-footer-menu ${isMobile ? 'site-footer-menu_mobile' : ''}`}
		>
			{Object.keys(footerMenu).map((title, index) => (
				<FooterMenuColumn title={title} key={index} />
			))}
		</nav>
	);
};

export default FooterMenu;
